const INITIAL_STATE = {
  data: {},
  errors: {},

}
const addGroup = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_GROUP_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_GROUP_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default addGroup;